module.exports = __webpack_public_path__ + "img/stackslash-process-4.237513f7.jpg";